// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__lqub8","iconWrap":"styles_iconWrap__sL5FX"};
module.exports.__checksum = "d03075c62eb1"
